import React from "react";
import PropTypes from "prop-types";
import QuestionBody from "../QuestionBody";
import QuestionHeader from "../QuestionHeader";
import styles from "./QuestionContainer.module.scss";
import QuestionFooter from "../QuestionFooter";

/** Controls the components for asking & answering questions */

function QuestionContainer(props) {
  const { state, handlers } = props;
  return (
    <Container>
      <QuestionHeader
        questions={state.questions}
        currentQuestion={state.currentQuestion}
        progress={state.progress}
      />
      <QuestionBody
        answers={state.answers}
        currentQuestion={state.currentQuestion}
        handleSelection={handlers.handleSelectAnswer}
      />
      <QuestionFooter
        questions={state.questions}
        currentQuestion={state.currentQuestion}
        backDisabled={state.backDisabled}
        nextHidden={state.nextHidden}
        handleNext={handlers.handleNext}
        handleBack={handlers.handleBack}
        handleSubmit={handlers.handleSubmit}
        progress={state.progress}
      />
    </Container>
  );
}

QuestionContainer.propTypes = {
  state: PropTypes.shape({
    backDisabled: PropTypes.bool,
    currentQuestion: PropTypes.shape({
      answer: PropTypes.string,
      dimension: PropTypes.string,
      id: PropTypes.number,
      question: PropTypes.string,
      subDimension: PropTypes.string,
    }),
    isComplete: PropTypes.bool,
    nextHidden: PropTypes.bool,
    progress: PropTypes.number,
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        answer: PropTypes.string,
        dimension: PropTypes.string,
        id: PropTypes.number,
        question: PropTypes.string,
        subDimension: PropTypes.string,
      })
    ),
  }),
};

function Container({ children }) {
  return <div className={styles.container}>{children}</div>;
}

Container.propTypes = {
  children: PropTypes.node,
};

export default QuestionContainer;
